import { Button, EmptyState, type IconName } from "@nexus/ui";
import { useTranslation } from "react-i18next";

export interface PersonaOpportunityTabPlaceholderProps {
  titleKey: string;
  titleFallback?: string;
  descriptionKey: string;
  descriptionFallback?: string;
  icon?: IconName;
  actionLabelKey?: string;
  actionLabelFallback?: string;
  onAction?: () => void;
}

export function PersonaOpportunityTabPlaceholder({
  titleKey,
  titleFallback,
  descriptionKey,
  descriptionFallback,
  icon = "layout-grid",
  actionLabelKey,
  actionLabelFallback,
  onAction,
}: PersonaOpportunityTabPlaceholderProps) {
  const { t } = useTranslation();

  return (
    <EmptyState
      icon={icon}
      title={titleFallback ? t(titleKey, titleFallback) : t(titleKey)}
      description={
        descriptionFallback ? t(descriptionKey, descriptionFallback) : t(descriptionKey)
      }
      className="px-6 py-16 [&_h3]:text-[15px] [&_p]:max-w-[420px] [&_p]:text-[13px] [&_p]:leading-relaxed"
      action={
        actionLabelKey && onAction ? (
          <Button
            type="button"
            className="h-9 bg-foreground px-4 font-medium text-background hover:bg-foreground/90"
            onClick={onAction}
          >
            {actionLabelFallback ? t(actionLabelKey, actionLabelFallback) : t(actionLabelKey)}
          </Button>
        ) : undefined
      }
    />
  );
}
